interface EmailData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export async function sendContactEmail(data: EmailData) {
  console.log('Envoi du message...', data);

  try {
    const response = await fetch('https://api.pokemonpocket.fr/contact.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Erreur serveur:', errorData);
      throw new Error(errorData.details || 'Erreur lors de l\'envoi de l\'email');
    }

    const result = await response.json();
    console.log('Réponse du serveur:', result);
    return result;
  } catch (error) {
    console.error('Erreur lors de l\'envoi de l\'email:', error);
    throw error;
  }
} 